import generateJavaRequest from './services/jrequest';

const jrequest = generateJavaRequest('oss');

export function getStsToken(conditions) {
  return jrequest('token', conditions);
}
